module.exports = __webpack_public_path__ + "static/media/11.42a84840.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/11.JPG
// module id = 452
// module chunks = 0